import React from 'react';
import { ContextApi, ContextForm } from 'react-uforms';

const FieldErrorComponent: React.FC<{
  name: string;
  className?: string;
  [key: string]: unknown;
}> = ({ name, className, ...props }) => (
  <ContextApi.Consumer>
    {api => (
      <ContextForm.Consumer>
        {() => {
          if (!api) {
            console.error('Could not found Form API. Make sure <FieldError/> is in the <Form/>.');
            return null;
          }
          const errors = api.getErrors(name);
          const classNames = className ? [className] : [];
          const { error: errorClassName } = api.getClasses<'field'>('field');
          if (errorClassName) {
            classNames.push(errorClassName);
          }

          const errorsArray = errors => errors.map((error, i) => <p key={`error-name-${i}`}>{error}</p>);
          return errors?.length > 0 ? (
            <div {...props} className={classNames.join(' ')}>
              {Array.isArray(errors) ? errorsArray(errors) : errors}
            </div>
          ) : null;
        }}
      </ContextForm.Consumer>
    )}
  </ContextApi.Consumer>
);

FieldErrorComponent.displayName = 'FieldError';

export const FieldError = FieldErrorComponent;
